import type { FaireProductEntity } from "../../entity_types/product";

export const p_4vsgtd7gbs: FaireProductEntity = {
  token: "p_4vsgtd7gbs",
  type: "product",
  name: "Night Sky Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/4dafda222df558f40e1dcf9bce2d05f042adb2b443b59df604500506bd304d9b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7cd6ec0c7de12ef934d69bfe45ea4c3b4ea479bee65a4285f50221e9dc247fdf.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:14.197Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
